export default __webpack_public_path__ + "static/media/fasting_overeating@3x.fe2ba1e8.jpg";